import { render } from "./NewPatientOrder.vue?vue&type=template&id=b56c864e"
import script from "./NewPatientOrder.vue?vue&type=script&lang=js"
export * from "./NewPatientOrder.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/orders/NewPatientOrder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b56c864e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b56c864e', __exports__)) {
    console.log('reload')
    api.reload('b56c864e', __exports__)
  }
  
  module.hot.accept("./NewPatientOrder.vue?vue&type=template&id=b56c864e", () => {
    console.log('re-render')
    api.rerender('b56c864e', render)
  })

}


export default __exports__